// extracted by mini-css-extract-plugin
module.exports = {"fields":"fields___GZrcw","row":"row___27kc7","name":"name___3f30B","letter":"letter___qeNeL"};